// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"b0dbaa41","605":"a8668fb0","981":"2a200e47"}[chunkId] + ".chunk.js";
};